/* eslint-disable camelcase, import/prefer-default-export */
import { AxiosResponse } from 'axios';
import * as INFO from './INFO';

export const API = 'permission/role/modify';

export interface request extends INFO.request { }

export interface AxiosResponse extends AxiosResponse<responseExtends> { }

interface responseExtends extends backendResponse {
  response: response
}

export interface response extends INFO.response { }

export interface p4_node extends INFO.p4_node { }

export interface node extends INFO.node { }

export interface role_node extends INFO.role_node { }
